import { getCurrentUser } from 'graphpl/core/queries';
import { timeAsync } from 'helpers/logger';
import type { ApolloClientType } from 'api/apollo/client';
import type { User } from 'contexts/user-context';
import { GraphQLError } from 'graphql';

type GetDefaultPropsReturn = {
  user: null | User;
  authenticated: boolean;
  errors: readonly GraphQLError[];
};

type GetDefaultProps = (
  apolloClient: ApolloClientType,
) => Promise<GetDefaultPropsReturn>;

const getDefaultProps: GetDefaultProps = async (apolloClient) => {
  let user = null;
  let authenticated;
  let fetchErrors: readonly GraphQLError[] = [];

  try {
    const { data, errors } = await apolloClient.query({
      query: getCurrentUser,
      fetchPolicy: 'network-only',
      errorPolicy: 'all', // This prevents the error being thrown and instead returns the errors array.
    });

    fetchErrors = errors;

    const authenticationError = errors?.find(
      // @ts-ignore
      (error) => error?.error === 'not_authenticated',
    );

    if (authenticationError) {
      authenticated = false;
    }
    if (!authenticationError) {
      user = data.currentUser;
      authenticated = true;
    }
  } catch (e) {
    authenticated = false;
  }

  return { user, authenticated, errors: fetchErrors || [] };
};

export default timeAsync<[ApolloClientType], GetDefaultPropsReturn>(
  getDefaultProps,
  'getDefaultProps',
);

export type { GetDefaultPropsReturn };
